import { TableCell } from "@mui/material";
import { FC } from "react";

import {
  ConflictKeysType,
  IConflict,
  onActivateKeyDown,
  useFormats,
} from "@ryde/shared";
import { blueMui } from "@ryde/theme";

interface IBookingConflictsTableCellProps {
  conflictKey: keyof IConflict;
  conflictValue: IConflict[keyof IConflict];
  isBooking: boolean;
  isPassenger: boolean;
  isStationName: boolean;
  onBookingEdit: () => void;
  onPassengerEdit: () => void;
  onStationEdit: () => void;
}

export const ConflictsTableCell: FC<IBookingConflictsTableCellProps> = ({
  conflictKey,
  conflictValue,
  isBooking,
  isPassenger,
  isStationName,
  onBookingEdit,
  onPassengerEdit,
  onStationEdit,
}) => {
  const { formatDateTimeNormalized } = useFormats();

  if (conflictKey === ConflictKeysType.errorType) {
    return null;
  }

  if (conflictKey === ConflictKeysType.bookingId && isBooking) {
    return (
      <TableCell>
        <div
          className="cell_simple pointer"
          onClick={onBookingEdit}
          onKeyDown={onActivateKeyDown(onBookingEdit)}
          role="button"
          tabIndex={0}
          color={blueMui.A400}
        >
          {String(conflictValue)}
        </div>
      </TableCell>
    );
  }

  if (conflictKey === ConflictKeysType.workerCode && isPassenger) {
    return (
      <TableCell>
        <div
          className="cell_simple pointer"
          onClick={onPassengerEdit}
          onKeyDown={onActivateKeyDown(onPassengerEdit)}
          role="button"
          tabIndex={0}
          color={blueMui.A400}
        >
          {String(conflictValue)}
        </div>
      </TableCell>
    );
  }

  if (conflictKey === ConflictKeysType.passengerFullName && isPassenger) {
    return (
      <TableCell>
        <div
          className="cell_simple pointer"
          onClick={onPassengerEdit}
          onKeyDown={onActivateKeyDown(onPassengerEdit)}
          role="button"
          tabIndex={0}
          color={blueMui.A400}
        >
          {String(conflictValue)}
        </div>
      </TableCell>
    );
  }

  if (conflictKey === ConflictKeysType.stationName && isStationName) {
    return (
      <TableCell>
        <div
          className="cell_simple pointer"
          onClick={onStationEdit}
          onKeyDown={onActivateKeyDown(onStationEdit)}
          role="button"
          tabIndex={0}
          color={blueMui.A400}
        >
          {String(conflictValue)}
        </div>
      </TableCell>
    );
  }

  if (conflictKey === ConflictKeysType.date) {
    return (
      <TableCell>
        {formatDateTimeNormalized(conflictValue as TDateISO)}
      </TableCell>
    );
  }

  return <TableCell>{String(conflictValue)}</TableCell>;
};
